module.exports = {"pathContext":{"slug":"/it/3d/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-3-d.json
// module id = 1567
// module chunks = 30787653422453